<template>
  <registration :form-fields="fields"
                :conditions="conditions"
                :registration="registerUser"
                :intro-text="t('_CheckContactInfoTxt')"
  />
</template>
<script>
    import VueFormGenerator from 'vue-form-generator';
    import Registration from '../../core/Components/User/Registration.vue';

    export default {
        components: {
            Registration
        },
        methods: {
            registerUser(data) {
                return this.$store.dispatch('account/register', data);
            },
        },
        data() {
            return {
                conditions: [
                    {
                        label: this.t('Conditions terms label'),
                        title: this.t('Condition terms title'),
                        clickText: this.t('Conditions click text'),
                        model: 'consentTerms',
                        text: this.t('_Registration conditions terms'),
                        required: true,
                        default: false
                    },
                    {
                        label: this.t('Marketing purposes consent'),
                        model: 'consentMarketing',
                        required: false,
                        default: false
                    },
                    {
                        label: this.t('Survey invitations consent'),
                        model: 'consentInvitations',
                        required: false,
                        default: false
                    }
                ],
                fields: [
                    {
                        type: 'input',
                        inputType: 'text',
                        label: this.t('Title prefix'),
                        model: 'titlePrefix',
                        required: false,
                        max: 40,
                        validator: VueFormGenerator.validators.string,
                    }, {
                        type: 'input',
                        inputType: 'text',
                        label: this.t('Firstname'),
                        model: 'firstname',
                        required: true,
                        validator: VueFormGenerator.validators.required
                    }, {
                        type: 'input',
                        inputType: 'text',
                        label: this.t('Lastname'),
                        model: 'lastname',
                        required: true,
                        validator: VueFormGenerator.validators.required
                    }, {
                        type: 'input',
                        inputType: 'text',
                        label: this.t('Title sufix'),
                        model: 'titleSufix',
                        required: false,
                        max: 40,
                        validator: VueFormGenerator.validators.string,
                    }, {
                        type: 'input',
                        inputType: 'text',
                        label: this.t('E-mail address'),
                        model: 'login',
                        required: true,
                        hint: this.t('You will use your e-mail address as your username when signing in'),
                        validator: VueFormGenerator.validators.email
                    }, {
                        type: 'password',
                        label: this.t('Password'),
                        model: 'password',
                        required: true,
                        validator: function (value, field, model) {
                            if (model.hasOwnProperty('password') && model.password && model.password.length > 0) {
                                if(model.password.length < 6) {
                                    return [this.t('Password is too short. Please choose a password with at least 6 characters')];
                                }
                                if(model.password.length > 40) {
                                    return [this.t('Password is too long. Please choose a password no longer than 40 characters')];
                                }
                            }
                            else {
                                return VueFormGenerator.validators.required(value, field, model);
                            }
                        }
                    },
                    {
                        type: 'input',
                        inputType: 'password',
                        label: this.t('Repeat password'),
                        model: 'repeatPassword',
                        required: true,
                        max: 40,
                        min: 6,
                        validator: function (value, field, model) {
                            if (model.password !== model.repeatPassword) {
                                return [this.t('Passwords are not equal')];
                            }
                            return VueFormGenerator.validators.required(value, field, model);
                        }
                    },
                    {
                        type: 'input',
                        inputType: 'text',
                        label: this.t('Cellphone'),
                        model: 'cellphone',
                        required: true,
                        hint: this.t('Value must match format "0900123456"'),
                        validator: (value) => {
                            if (value) {
                                return null === value.match(/^[0-9]{10}$/) ? [this.t('Please enter your phone number in required format')] : []
                            } else {
                                return [this.t('Please enter your mobile phone number')]
                            }
                        }
                    }, {
                        type: 'titanSelect',
                        codeBook: 'panel',
                        label: this.t('Speciality'),
                        model: 'panel',
                        // model: 'panel_id',
                        default: 1,
                        required: true,
                        validator: VueFormGenerator.validators.required,
                        disabled: this.editable === false,
                    }
                ]
            }
        }
    }
</script>
<style lang="scss">
  .form-sign-in {
    .conditions-text {
      float: left;
      font-size: 14px;
      width: 90%;
    }

    .conditions-checkbox {
      margin-right: 10px;
      float: left;
    }

    .condition-line {
      float: left;
      margin-bottom: 0.3rem !important;
    }

    .conditions-error {
      float: left;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/public/Register.vue